import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DriversWithdrawalRequestService } from "./driver-withdrawal-request.service";
import * as XLSX from "xlsx";

@Component({
  selector: "app-driver-withdrawal-request",
  templateUrl: "./driver-withdrawal-request.component.html",
  styleUrls: ["./driver-withdrawal-request.component.sass"],
})
export class DriverWithdrawalRequestComponent implements OnInit {
  constructor(
    private withdrawalService: DriversWithdrawalRequestService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.amountWithdrawalRequest();
  }
  closeResult: string;

  page: Number = 0;
  itemsPerPage: Number = 5;
  totalItems: number = 0;
  withdrawalRequests: any[] = [];
  amountWithdrawalRequest() {
    this.spinner.show();
    let data = {
      page: 0,
      perPage: this.itemsPerPage,
    };
    // console.log("data", data);
    this.withdrawalService
      .getDriverWithdrawalReq(data)
      .subscribe((result: any) => {
        this.spinner.hide();
        // console.log("withdrawal Requests", result);
        if (result.statusCode == 200) {
          this.withdrawalRequests = result.data;
          this.totalItems = result.totalRecords;
        } else {
          this.toastr.error(result.message);
          this.withdrawalRequests = [];
        }
      });
  }
  gty(page: number) {
    this.spinner.show();
    let data = {
      page: Number(this.page) - 1,
      perPage: this.itemsPerPage,
    };
    // console.log("data", data);
    this.withdrawalService
      .getDriverWithdrawalReq(data)
      .subscribe((result: any) => {
        this.spinner.hide();
        // console.log("withdrawal Requests", result);
        if (result.statusCode == 200) {
          this.withdrawalRequests = result.data;
          this.totalItems = result.totalRecords;
        } else {
          this.toastr.error(result.message);
          this.withdrawalRequests = [];
        }
      });
  }

  rejectReason: any = "";
  updateWithdrawalRequest(id: "", status: "") {
    this.spinner.show();
    let data = {
      id: id,
      status: status,
      rejectedReason: this.rejectReason,
    };
    // console.log("Update Status", data);
    this.withdrawalService
      .updateDriverWithdrawalReq(data)
      .subscribe((result: any) => {
        this.spinner.hide();
        if (result.statusCode == 200) {
          // console.log("Response Update Status", result);
          this.toastr.success(result.message);
          this.modalService.dismissAll();
          this.amountWithdrawalRequest();
        } else {
          this.toastr.error(result.message);
        }
      });
  }

  searchBy: any = "";
  searchText: any = "";
  search() {
    this.spinner.show();
    let data = {
      fieldName: this.searchBy,
      searchText: this.searchText,
    };
    // console.log(data);
    this.withdrawalService
      .searchWalletRequest(data)
      .subscribe((result: any) => {
        this.spinner.hide();
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.withdrawalRequests = result.data;
        } else {
          this.toastr.error(result.message);
          this.withdrawalRequests = [];
        }
      });
  }

  // Rejection modal
  showOtherReason: boolean = false;
  isFormValid: boolean = false;

  onReasonSelect(reason: string) {
    if (reason == "Other") {
      this.rejectReason = "";
      console.log("reason", this.rejectReason);
      this.showOtherReason = true;
    } else {
      this.rejectReason = reason;
      console.log("reason", this.rejectReason);
      this.showOtherReason = false;
    }
  }
  confirmRejection() {
    console.log("Rejection confirmed:", this.rejectReason);
  }

  modelId: any;
  rejectModel(content, data) {
    this.modelId = data._id;
    this.openchangeStatusModal(content);
  }

  openchangeStatusModal(content) {
    this.modalService.open(content).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      this.rejectReason = "";
      this.showOtherReason = false;
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      this.rejectReason = "";
      this.showOtherReason = false;
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  // export to excel

  exportToExcel() {
    // Filter to include only the required fields for the report
    console.log(this.withdrawalRequests);
    const data = this.withdrawalRequests.map((item) => ({
      DriverName: item.driverName,
      PhoneNumber: item.phoneNumber,
      Amount: item.amount,
      PaymentMethod: item.paymentMethod,
      WithdrawalStatus: item.status,
      Date: new Date(item.timestamp * 1000).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    }));

    // Convert the filtered array to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Generate a workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Save the file with a more dynamic name if needed
    XLSX.writeFile(wb, "Driver Withdrawal Report.xlsx");
  }

  allWithdrawalReq: any;
  exportAll() {
    this.spinner.show();
    let data = {
      page: 0,
      perPage: this.totalItems,
    };
    // console.log("data", data);
    this.withdrawalService
      .getDriverWithdrawalReq(data)
      .subscribe((result: any) => {
        this.spinner.hide();
        // console.log("withdrawal Requests", result);
        if (result.statusCode == 200) {
          this.allWithdrawalReq = result.data;
          this.exportAllToExcel(this.allWithdrawalReq)
        } else {
          this.toastr.error(result.message);
          this.allWithdrawalReq = [];
        }
      });
  }

  exportAllToExcel(array: any) {
    // console.log(array)
    const data = array.map((item) => {
      return {
        DriverName: item.driverName,
        PhoneNumber: item.phoneNumber,
        Amount: item.amount,
        PaymentMethod: item.paymentMethod,
        WithdrawalStatus: item.status,
        CreatedOn: new Date(item.timestamp * 1000).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      };
    });

    // Convert the filtered array to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Generate a workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Save the file
    XLSX.writeFile(wb, "Drivers Withdrawal Report.xlsx");
  }
}
